interface Feature {
  icon: string;
  title: string;
  description: string;
}

interface ProcessStep {
  number: string;
  title: string;
  description: string;
}

interface ServiceContentProps {
  features: Feature[];
  benefits: string[];
  processSteps: ProcessStep[];
}

export default function ServiceContent({ features, benefits, processSteps }: ServiceContentProps) {
  return (
    <section className="py-14 md:py-20 px-4">
      <div className="max-w-6xl mx-auto">

        {/* Features */}
        <div className="mb-12 md:mb-16">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-8 text-center">What We Offer</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {features.map((feature, index) => (
              <div key={index} className="bg-gray-50 rounded-xl p-6 text-center hover:shadow-md transition-shadow duration-300">
                <div className="w-12 h-12 flex items-center justify-center bg-orange-100 rounded-full mx-auto mb-4">
                  <i className={`${feature.icon} text-2xl text-orange-500`}></i>
                </div>
                <h3 className="text-base font-bold text-gray-900 mb-2">{feature.title}</h3>
                <p className="text-sm text-gray-600 leading-relaxed">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Benefits */}
        <div className="mb-12 md:mb-16">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-8">Why Choose Us</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4">
            {benefits.map((benefit, index) => (
              <div key={index} className="flex items-start gap-3">
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-checkbox-circle-fill text-xl text-orange-500"></i>
                </div>
                <p className="text-sm md:text-base text-gray-700">{benefit}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Process Steps */}
        <div>
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-8">Our Process</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
            {processSteps.map((step, index) => (
              <div key={index} className="relative">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-orange-500 text-white rounded-full font-bold text-base flex-shrink-0">
                    {step.number}
                  </div>
                  <h3 className="text-base font-bold text-gray-900">{step.title}</h3>
                </div>
                <p className="text-sm text-gray-600 leading-relaxed pl-13">
                  {step.description}
                </p>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
}
